import * as Sentry from '@sentry/react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';

import { router } from './Routes/Router';

Sentry.init({
    dsn: 'https://810bf695612e54defe8ee9792f260185@o4509429256028160.ingest.de.sentry.io/4509429258715216',
    enabled: !process.env.DEV,
    integrations: [
        Sentry.captureConsoleIntegration({
            levels: ['error'],
        }),
    ],
    sendDefaultPii: false,
});

ReactDOM.createRoot(document.getElementById('root')!).render(<RouterProvider router={router} />);
